import { create } from "zustand";
import { MutableRefObject } from "react";

interface PortalReferenceSlice {
    portalRef: MutableRefObject<HTMLDivElement | undefined> | undefined;
    setPortalRef: (value: MutableRefObject<HTMLDivElement | undefined>) => void;
}
export const usePortalReference = create<PortalReferenceSlice>()((set) => ({
    portalRef: undefined,
    setPortalRef: (portalRef) =>
        set({
            portalRef,
        }),
}));
